// "Waiting for a Sales Quote" = still actionable (not closed/lost) and no Sales Quote linked. Mirrors backend request_trail.py.
const CLOSED_REQUEST = ['closed', 'lost', 'cancelled', 'rejected'];
const CLOSED_FABRIC = ['won', 'lost', 'cancelled', 'rejected'];

export const isWaitingConfigurator = (r) => !r.linked_quote_id && !CLOSED_REQUEST.includes(r.status);
export const isWaitingFabric = (r) => !r.quote_id && !CLOSED_FABRIC.includes(r.status);
export const isWaitingContact = (c) => !c.linked_quote_id && !CLOSED_REQUEST.includes(c.status);
